import { render, staticRenderFns } from "./ApprovePaymentPage.vue?vue&type=template&id=1287097f&"
import script from "./ApprovePaymentPage.vue?vue&type=script&lang=js&"
export * from "./ApprovePaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePaymentPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports